export default function Tabs(links, content) {
  if (links.length > 0 && content.length > 0) {
    for (let i = 0; i < links.length; i++) {
      let link = links[i];

      // First, we need to check if it's a valid node element
      if (link.nodeType === Node.ELEMENT_NODE) {
        link.addEventListener('click', function () {
          // clear the tabs
          for (i = 0; i < content.length; i++) {
            content[i].style.display = 'none';
          }

          // clear the links
          for (i = 0; i < links.length; i++) {
            links[i].classList.remove('current');
          }

          this.classList.add('current');
          document.querySelector(
            `.tab__content--${this.getAttribute('data-tab')}`
          ).style.display = 'block';
        });
      }
    }
  } else {
    return null;
  }
}
